import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { isSessionSet } from 'selectors/user/session'
import { getHasValidPermissions, getIsUsersArtworksAccount } from '../selectors/app'

const mapStateToProps = createStructuredSelector({
  hasValidPermissions: getHasValidPermissions,
  isUsersArtworksAccount: getIsUsersArtworksAccount,
  isSet: isSessionSet,
})

export type ConnectorProps = {
  hasValidPermissions: boolean
  isUsersArtworksAccount: boolean
  isSet: boolean
}
export default connect(mapStateToProps)
